export default __webpack_public_path__ + "static/media/coming-soon-circle.f26be8a1.svg";